import { CoreSessionStorage } from '../storage/session/CoreSessionStorage';

export const DEFAULT_LANGUAGE_CODE = 'en';
const RTL_LANGUAGES = ['ar', 'fa'];

/**
 * Retrieves the current language based on provided 'lang' parameter from the session URL or defaults to English.
 * It ensures the language code is among the available languages provided;
 * otherwise, it falls back to English. The resolved language code is stored
 * in session storage for access outside the core settings slice.
 *
 * @param {string[]} languages - An array of available language codes,
 * coming from `/src/config/languages.ts`, either defined manually or auto-generated by @pp/translator library.
 * @param sessionLanguageCode - The language code obtained from the session URL `lang` parameter.
 * @returns {string} The current language code.
 */
export const getCurrentLanguage = (languages: string[], sessionLanguageCode: string | undefined | null): string => {
  const userLanguageCode: string = sessionLanguageCode ?? DEFAULT_LANGUAGE_CODE;
  const currentLanguageCode: string = languages.includes(userLanguageCode) ? userLanguageCode : DEFAULT_LANGUAGE_CODE;

  CoreSessionStorage.setLang(currentLanguageCode);

  return currentLanguageCode;
};

/**
 * Determines if the given language code corresponds to a Right-to-Left (RTL) language.
 *
 * @param {string} languageCode - The language code to check.
 * @returns {boolean} True if the language is RTL; false otherwise.
 */
export const getIsLanguageRTL = (languageCode: string): boolean => {
  return RTL_LANGUAGES.includes(languageCode);
};
